export default {
  dSummaries: []
}
